<!-- eslint-disable vue/valid-v-slot -->

<template>
  <div class="fuelcards-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Karty paliwowe</h1>
      </div>
      <button
        class="action-pill action-pill--primary"
        @click="dialog = true; action = 'Tworzenie'; currentFuelCardId = null"
      >
        <v-icon size="14">mdi-plus</v-icon>{{ $t('common.add') }}
      </button>
    </div>
    <v-data-table
          :headers="headers"
          :items="fuelCards"
          class="elevation-1"
          :loading="loading"
          :search="search"
          :options.sync="options"
          :server-items-length="totalItems"
        >
          <template v-slot:top>
            <div class="table-section-title">
              <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-card-account-details</v-icon></div>
              <div class="filter-title">{{ $t('fuelCards.title') }}</div>
            </div>
            <div class="search-row">
              <div class="search-input">
                <v-icon size="18" color="#6E7691">mdi-magnify</v-icon>
                <input v-model="search" type="text" :placeholder="$t('common.search')" />
              </div>
            </div>
          </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoFuelCard(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.historyFuelCard="{ item }">
            <v-btn class="info" @click="historyFuelCard(item.id)"
              ><v-icon small class="pt-1">mdi-history</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteFuelCard="{ item }">
            <v-btn class="error" @click="deleteFuelCard(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
    </v-data-table>
    <!-- History Dialog -->
    <v-dialog content-class="dark-form-dialog" v-model="historyDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Fuel Card History - {{ selectedCard }}</span
          >
        </v-card-title>

        <v-card-text>
          <!-- Timeline -->
          <v-timeline dense>
            <v-timeline-item
              v-for="(event, index) in selectedCardHistory"
              :key="index"
              :color="event.color || 'blue'"
              :icon="event.icon || 'mdi-calendar'"
            >
              <template>
                <strong>{{ event.createdAt }}</strong>
              </template>
              <v-card>
                <v-card-text style="white-space: break-spaces;">{{ event.description }}</v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog -->
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('fuelCards.fuelCard') }}</span>
        </v-card-title>

        <v-card-text>
          <!-- Form -->
          <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
            <v-row>
              <!-- Number -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.number"
                  :label="$t('fuelCards.number')"
                  outlined
                  required
                  :rules="[validateRequired]"
                />
              </v-col>

              <!-- Provider -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.provider"
                  :label="$t('fuelCards.provider')"
                  outlined
                  required
                  :rules="[validateRequired]"
                />
              </v-col>

              <!-- Car ID (Select) -->
              <v-col cols="12">
                <v-select
                  v-model="formData.carId"
                  :items="cars"
                  item-text="name"
                  item-value="id"
                  label="Car"
                  outlined
                  :rules="[validateOptionalUUID]"
                  return-object
                />
              </v-col>
              <!-- Car ID (Select) -->
              <v-col cols="12">
                <v-select
                  v-model="formData.driverId"
                  :items="drivers"
                  item-text="name"
                  item-value="id"
                  :label="$t('common.driver')"
                  outlined
                  :rules="[validateOptionalUUID]"
                  return-object
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="closeDialog">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" @click="submitForm" :disabled="!valid">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      historyDialog: false,
      selectedCard:"",
      selectedCardHistory: [],
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        {
          text: "Numer",
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: "Dostawca",
          align: "start",
          sortable: false,
          value: "provider",
        },
        {
          text: "Kierowca",
          align: "start",
          sortable: false,
          value: "driver",
        },
        {
          text: "Pojazd",
          align: "start",
          sortable: false,
          value: "car",
        },

        { text: "", value: "details", sortable: false },
        { text: "", value: "historyFuelCard", sortable: false },
        { text: "", value: "deleteFuelCard", sortable: false },
      ],
      fuelCards: [],
      totalItems: 0,
      dialog: false, // Controls dialog visibility
      valid: false, // Form validity
      currentCardId: null,
      formData: {
        number: "", // Required
        provider: "", // Required
        carId: null, // Selected Car (Object: { id, name })
        driverId: null,
      },
      cars: [],
      drivers:[],
    };
  },
 watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    validateUUID(value) {
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return !value || uuidRegex.test(value) || "Nieprawidłowy format UUID";
    },
    validateOptionalUUID(value) {
      return value === null || this.validateUUID(value.id || value);
    },
    validateRequired(value) {
      return !!value || "To pole jest wymagane";
    },
    async submitForm() {
      if (!this.valid) return;
      try {
        await this.toggleLoading(true);
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "fuel-cards",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: {
            ...this.formData,
            carId: this.formData.carId.id,
            driverId: this.formData.driverId.id,
            id: this.currentCardId || undefined,
          },
        });
        this.closeDialog();
        await this.toggleLoading(false);
        await this.initialize();
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    closeDialog() {
      this.dialog = false;
      this.currentCardId = undefined;
      this.$refs.form.resetValidation(); // Reset form validation
    },
    async infoFuelCard(id) {
      await this.toggleLoading(true);
      try {
        const card = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "fuel-cards/details/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.formData = card.data.data;
        this.currentCardId = card.data.data.id;
        this.formData.carId = card.data.data.carId;
        this.formData.driverId = card.data.data.driverId;
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async historyFuelCard(id) {
      await this.toggleLoading(true);
      try {
            const card = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "fuel-cards/details/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.selectedCard = card.data.data.number;
        const history = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "fuel-cards/history/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.selectedCardHistory = history.data.data.map((it) => {
          return {
            id: it.id,
            description: it.description,
            createdAt: dayjs().format("DD-MM-YYYY HH:mm"),
          };
        });
        this.historyDialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async initialize() {
      this.loading = true;
      await this.getCarsSelect();
      if (this.search.trim().length > 0) {
        this.options.page = 1;
      }
      try {
        const cards = await axios({
          method: "get",
          url:
            process.env.VUE_APP_ROOT_API +
            `fuel-cards?take=${this.options.itemsPerPage}&skip=${this.options.page}&search=${this.search}`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.fuelCards = cards.data.data.result.map((card) => {
          return {
            number: card.number,
            provider: card.provider,
            car: card.car
              ? `${card.car.make}-${card.car.model} ${card.car.plate}`
              : "",
              driver: card.driver
              ? `${card.driver.firstName} ${card.driver.lastName}`
              : "",
            id: card.id,
          };
        });
        this.totalItems = cards.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async getCarsSelect() {
      await this.toggleLoading(true);
      try {
        const cars = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `cars?take=10&skip=1`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.cars = cars.data.data.result.map((it) => {
          return {
            id: it.id,
            name: `${it.make}-${it.model} ${it.plate}`,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async getDriversSelect() {
      await this.toggleLoading(true);
      try {
        const drivers = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `drivers?take=1000&skip=1`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.drivers = drivers.data.data.result.map((it) => {
          return {
            id: it.id,
            name: `${it.firstName} ${it.lastName}`,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async deleteFuelCard(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "fuel-cards/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.fuelcards-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.action-pill { display: inline-flex; align-items: center; gap: 6px; background: #2962FF; border: 1px solid #2962FF; color: #fff; padding: 8px 14px; border-radius: 10px; font-size: 12.5px; font-weight: 600; cursor: pointer; box-shadow: 0 4px 12px rgba(41,98,255,0.3); transition: transform 0.12s ease; font-family: inherit; }
.action-pill:hover { transform: translateY(-1px); }
.action-pill .v-icon { color: inherit !important; }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; flex-grow: 1; }
.search-row { padding: 10px 14px 14px; }
.search-input { display: flex; align-items: center; gap: 8px; background: #181C28; border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 10px 14px; }
.search-input input { flex: 1; background: transparent; border: none; outline: none; color: #fff; font-size: 14px; font-family: inherit; }
.search-input input::placeholder { color: #6E7691; }

.fuelcards-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.fuelcards-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; font-size: 15px !important; }
.fuelcards-page >>> .v-text-field--outlined fieldset, .fuelcards-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.fuelcards-page >>> .v-text-field--outlined .v-input__slot, .fuelcards-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.fuelcards-page >>> .v-label { color: #6E7691 !important; }
.fuelcards-page >>> .v-text-field input, .fuelcards-page >>> .v-select__selection { color: #fff !important; }
.fuelcards-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.fuelcards-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.fuelcards-page >>> .v-data-table tbody tr { background: #232838 !important; }
.fuelcards-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.fuelcards-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.fuelcards-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.fuelcards-page >>> .v-data-table tbody td .v-btn.warning { background: rgba(255,152,0,0.18) !important; color: #FFB74D !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.fuelcards-page >>> .v-data-table tbody td .v-btn.error { background: rgba(244,67,54,0.18) !important; color: #FF8A80 !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.fuelcards-page >>> .v-data-table tbody td .v-btn.info { background: rgba(66,165,245,0.18) !important; color: #64B5F6 !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.fuelcards-page >>> .v-data-table tbody td .v-btn .v-icon { color: inherit !important; }
.fuelcards-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.fuelcards-page >>> .v-btn:not(.v-btn--icon):not(.action-pill) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.fuelcards-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.fuelcards-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.fuelcards-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.fuelcards-page >>> .v-dialog .v-card { background: #232838 !important; }

/* Add custom styles if needed */
</style>
